import { Route, Routes } from '@angular/router';

import { Flags } from '@shared/services/launch-darkly.service';

type Flag = keyof Flags;

export const buildRoutesByFeatureFlags = (
  featureFlags: Flags | null,
  flagRoutes: Routes
): Routes => {
  return flagRoutes.reduce((routes: Routes, featureFlagRoute: Route) => {
    const clonedRoute = { ...featureFlagRoute };

    let isFeatureFlagRouteEnabled: boolean | null = true;

    if (featureFlagRoute.data?.feature) {
      isFeatureFlagRouteEnabled =
        featureFlags && !!featureFlags[featureFlagRoute.data?.feature as Flag];
    }

    if (featureFlagRoute.data?.features) {
      isFeatureFlagRouteEnabled = featureFlagRoute.data?.features.some(
        (feature: Flag) => featureFlags && !!featureFlags[feature]
      );

      if (isFeatureFlagRouteEnabled) {
        clonedRoute.children = buildRoutesByFeatureFlags(featureFlags, clonedRoute.children!);
      }
    }

    if (isFeatureFlagRouteEnabled) {
      return [...routes, clonedRoute];
    }

    return routes;
  }, []);
};

export enum FeatureFlag {
  ACCOUNT_SETTINGS = 'tab_profile_settings',
  BUDGET_CHANGE_LOG = 'tab_budget_changelog',
  BUDGET_CHANGE_ORDER = 'tab_change_order_review',
  BUDGET_ENHANCED = 'tab_budget_budget_enhanced',
  BUDGET_LIBRARY = 'tab_budget_budget_library',
  CHECKLIST_TAB = 'checklist_tab',
  CLOSING_RECONCILIATION = 'tab_budget_cash_management',
  COMPARE = 'tab_compare',
  FORECAST_DRIVERS = 'tab_forecast_drivers',
  FORECAST_STUDY_SPECS = 'tab_forecast_studyspecifications',
  IN_MONTH_ADJUSTMENTS = 'tab_in_month_adjustments',
  INVESTIGATOR_SITES = 'tab_investigator_sites',
  INVESTIGATOR_SUMMARY = 'tab_investigator_summary',
  INVESTIGATOR_TRANSACTIONS = 'tab_investigator_transactions',
  INVOICES = 'tab_invoices',
  JOURNAL_ENTRIES = 'tab_journal_entries',
  MONTH_AND_QUARTER_CLOSE = 'month_quarter_close_tab',
  PATIENT_BUDGET = 'tab_trial_settings_patient_protocol',
  PATIENT_TRACKER = 'nav_patient',
  PAYMENT_MILESTONES = 'tab_payment_milestones',
  PAYMENT_SCHEDULE = 'tab_budget_payment_schedule',
  PREPAIDS = 'prepaids',
  PROTOCOL_ENTRY = 'tab_protocol_entry',
  PURCHASE_ORDERS = 'tab_purchase_orders',
  SETTING_EXPENSE_DEFAULTS = 'expense_defaults',
  SETTINGS_EXCHANGE_RATES = 'tab_exchange_rates',
  SETTINGS_INTEGRATIONS = 'tab_integrations',
  SETTINGS_JE_CONFIGURATION = 'settings_journal_entry_configuration',
  SITES_INVESTIGATOR_DETAIL = 'tab_forecast_investigator_detail',
  SITES_INVESTIGATOR_FORECAST = 'tab_forecast_investigator_forecast',
  TRIAL_INSIGHTS = 'nav_trial_insights',
  USER_PERMISSIONS = 'tab_user_permissions',
  VENDORS = 'tab_vendors',
}
